import { useState, useEffect } from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Loader2, ScrollText } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const getAuthHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('admin_token')}` });

const ACTION_COLORS = {
  created: 'bg-emerald-100 text-emerald-700',
  updated: 'bg-blue-100 text-blue-700',
  deleted: 'bg-red-100 text-red-700',
  sent: 'bg-orange-100 text-orange-700',
  promoted: 'bg-violet-100 text-violet-700',
  matched: 'bg-teal-100 text-teal-700',
};

const actionColor = (action) => {
  const key = Object.keys(ACTION_COLORS).find(k => action.includes(k));
  return key ? ACTION_COLORS[key] : 'bg-gray-100 text-gray-600';
};

const AuditLogPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/retreat/audit-log?limit=300`, { headers: getAuthHeaders() })
      .then((res) => setLogs(res.data))
      .catch(() => toast.error('Failed to load audit log'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="p-6 flex items-center justify-center h-[50vh]"><Loader2 className="w-6 h-6 text-gray-300 animate-spin" /></div>;
  }

  return (
    <div className="p-6 max-w-5xl mx-auto" data-testid="audit-log-page">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Audit Log</h1>
        <p className="text-gray-600 mt-1">Who changed what, and when — most recent first</p>
      </div>

      <Card className="border-0 shadow-sm">
        <CardContent className="p-5">
          {logs.length === 0 ? (
            <div className="py-12 text-center text-gray-400" data-testid="audit-empty">
              <ScrollText className="w-8 h-8 mx-auto mb-3 text-gray-200" />
              No audit entries yet — actions will appear here as admins work
            </div>
          ) : (
            <div className="space-y-1" data-testid="audit-list">
              {logs.map((log) => (
                <div key={log.id} className="flex flex-wrap items-baseline gap-x-3 gap-y-1 py-2.5 border-b border-gray-50 text-sm">
                  <span className="text-xs text-gray-400 w-36 shrink-0">{new Date(log.timestamp).toLocaleString()}</span>
                  <span className="font-medium text-gray-700">{log.admin}</span>
                  <Badge className={`text-xs font-medium border-0 ${actionColor(log.action)}`}>{log.action}</Badge>
                  {log.target_name && <span className="text-gray-900 font-medium">{log.target_name}</span>}
                  {log.details && <span className="text-gray-500 text-xs">{log.details}</span>}
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AuditLogPage;
